import { SITE, IMAGES } from "@/lib/site";

export default function About() {
  return (
    <section
      id="about"
      data-testid="about-section"
      className="relative py-24 md:py-32 bg-bone"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-12 md:gap-16 items-center">
          {/* Image */}
          <div className="md:col-span-5 relative">
            <div className="absolute -top-5 -left-5 w-full h-full bg-brass/80 rounded-2xl -z-0" />
            <img
              src={IMAGES.headshot}
              alt={`Portrait of ${SITE.fullName}`}
              data-testid="about-headshot"
              className="relative z-10 rounded-2xl w-full aspect-square object-cover shadow-xl"
            />
            <p
              data-testid="about-family-caption"
              className="relative z-10 mt-6 font-display italic text-ink text-lg md:text-xl leading-snug tracking-tight"
            >
              My family is my <span className="not-italic font-semibold">why</span> —<br />
              Helping your family is my <span className="not-italic font-semibold">purpose</span>.
            </p>
          </div>

          {/* Text */}
          <div className="md:col-span-7">
            <p className="overline text-ink" data-testid="about-overline">
              About J.J.
            </p>
            <h2
              data-testid="about-heading"
              className="mt-5 font-display text-ink text-4xl sm:text-5xl lg:text-6xl leading-[1.05] tracking-tight"
            >
              Two licenses.
              <br />
              <span className="italic text-slate2">One signature.</span>
            </h2>
            <div className="mt-6 inline-flex items-center gap-2 px-3 py-1.5 rounded-full bg-brass/15 border border-brass/40 text-ink text-xs tracking-widest uppercase" data-testid="about-local-badge">
              <span className="w-1.5 h-1.5 rounded-full bg-brass" />
              Born &amp; raised · Fort Walton Beach
            </div>

            <p className="mt-8 text-text2 text-base md:text-lg leading-relaxed">
              Born and raised in <span className="font-semibold text-ink">Fort Walton Beach,
              Florida</span>, Florida's Emerald Coast isn't a market I work — it's home. I've
              spent my career helping families buy, sell, and finance homes across
              Okaloosa, Walton, and Santa Rosa Counties — from the sugar-white beaches of
              Destin to the bayous of Niceville to the 30A communities in Walton. On the
              mortgage side, I'm licensed to lend in all 50 U.S. states, which means I can
              finance your second home, vacation rental, or investment property anywhere in
              the country. Most clients work with two strangers — a Realtor and a mortgage
              officer — who barely speak. I am both. One signature, one number to call.
            </p>

            <ul className="mt-10 grid grid-cols-1 sm:grid-cols-2 gap-x-8 gap-y-6">
              {[
                {
                  title: "Realtor",
                  org: SITE.affiliations.realty,
                  copy: "Listing, buying, and investment strategy across Okaloosa, Walton & Santa Rosa Counties.",
                  license: SITE.licenses.realEstate,
                  logo: SITE.logos.coastalRealty,
                },
                {
                  title: "Mortgage Advisor",
                  org: SITE.affiliations.mortgage,
                  copy: "Conventional, FHA, VA, jumbo + Non-QM specialist (DSCR, Bank Statement, HELOC). Licensed in all 50 states.",
                  license: SITE.licenses.nmls,
                  logo: SITE.logos.edgeHomeFinance,
                },
              ].map((c) => (
                <li key={c.title}>
                  <div className="overline text-muted2">{c.title}</div>
                  <div className="mt-2 flex items-center gap-3">
                    <div className="flex-shrink-0 w-12 h-12 rounded-md bg-white border border-border2 inline-flex items-center justify-center p-1.5">
                      <img
                        src={c.logo}
                        alt={`${c.org} logo`}
                        className="max-w-full max-h-full object-contain"
                      />
                    </div>
                    <div className="font-display text-ink text-xl leading-tight">{c.org}</div>
                  </div>
                  <p className="text-text2/80 text-sm mt-3 leading-relaxed">{c.copy}</p>
                  <p className="text-muted2 text-xs mt-3 tracking-wide">{c.license}</p>
                </li>
              ))}
            </ul>
          </div>
        </div>
      </div>
    </section>
  );
}
